import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { addWeeks, format, addDays, subMonths, subWeeks, addMonths } from "date-fns";

import { getSelectedProgramPlan, calculateProratedClasses } from "./utils";

const OnlineOneTimeSemester = props => {
  const [subtotal, setSubtotal] = useState("Loading");
  const calculateSubtotal = () => {
    const plan = getSelectedProgramPlan(props.program, props.selected);

    let total_price = parseInt(plan.total_price);
    if (plan.isProrated) {
      const { totalSessions, sessionsPassed, amount } = calculateProratedClasses(props.program, plan.total_price);
      total_price = amount;
    }
    if (plan.addOnItems) {
      plan.addOnItems.map(item => {
        total_price += parseFloat(item.value);
      });
    }
    setSubtotal(
      parseFloat(
        parseFloat(
          total_price *
            (props.installments
              ? 1 + parseInt(plan.installments_interest) / 100
              : 1) || 0
        )
      ).toFixed(2)
    );
  };
  useEffect(() => {
    calculateSubtotal();
  }, []);
  return (
    <li
      style={{
        display: "flex",
        justifyContent: "space-between",
        padding: "15px 10px",
        borderBottom: "1px solid #dedede",
        fontSize: "14px"
      }}
    >
      <p
        style={{
          marginBottom: 0,
          fontFamily: "Open Sans, sans-serif",
          fontWeight: 500,
          fontSize: "14px"
        }}
      >
        Subtotal
      </p>
      <span style={{ fontWeight: 500 }}>${subtotal}</span>
    </li>
  );
};

OnlineOneTimeSemester.propTypes = {
  program: PropTypes.shape({
    plans: PropTypes.array.isRequired
  }).isRequired,
  selected: PropTypes.number.isRequired,
  installments: PropTypes.number.isRequired
};

export default OnlineOneTimeSemester;
